import Vue from "vue";
import VueRouter from "vue-router";
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};
Vue.use(VueRouter);
const routes = [
  {
    path: "/",
    name: "Home",
    component: () => import("@/views/index.vue")
  },
  {
    path: "/application",
    name: "application",
    component: () => import("@/views/application.vue")
  },
  {
    path: "/applicationTwo",
    name: "applicationTwo",
    component: () => import("@/views/applicationTwo.vue")
  },
  {
    path: "/hbrApplicationDesign",
    name: "hbrApplicationDesign",
    component: () => import("@/views/hbrApplicationDesign.vue")
  },
  {
    path: "/industryNews",
    name: "industryNews",
    component: () => import("@/views/industryNews.vue")
  },
  {
    path: "/companyNews",
    name: "companyNews",
    component: () => import("@/views/companyNews.vue")
  },
  {
    path: "/aboutUs",
    name: "aboutUs",
    component: () => import("@/views/aboutUs.vue")
  },
  {
    path: "/newProduct",
    name: "newProduct",
    component: () => import("@/views/newProduct.vue")
  },
  {
    path: "/installation",
    name: "installation",
    component: () => import("@/views/installation.vue")
  },
  {
    path: "/clean",
    name: "clean",
    component: () => import("@/views/clean.vue")
  },
  {
    path: "/questions",
    name: "questions",
    component: () => import("@/views/questions.vue")
  },
  {
    path: "/picture",
    name: "picture",
    component: () => import("@/views/picture.vue")
  },
  {
    path: "/contact",
    name: "contact",
    component: () => import("@/views/contact.vue")
  },
  {
    path: "/findDealer",
    name: "findDealer",
    component: () => import("@/views/findDealer.vue")
  },
  {
    path: "/test",
    name: "test",
    component: () => import("@/views/test.vue")
  },
  {
    path: "/simple",
    name: "simpleOne",
    component: () => import("@/views/simple.vue")
  },
  {
    path: "/simpleDetail",
    name: "simpleDetail",
    component: () => import("@/views/simpleDetail.vue")
  },
  {
    path: "/test",
    name: "test",
    component: () => import("@/views/test.vue")
  },
  {
    path: "/testPhone",
    name: "testPhone",
    component: () => import("@/views/testPhone.vue")
  },
  {
    path: "/testOne",
    name: "testOne",
    component: () => import("@/views/testOne.vue")
  },
  {
    path: "/testOnePhone",
    name: "testOnePhone",
    component: () => import("@/views/testOnePhone.vue")
  },
  {
    path: "/tree",
    name: "tree",
    component: () => import("@/views/tree.vue")
  },
  {
    path: "/search",
    name: "search",
    component: () => import("@/views/search.vue")
  }
];

const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  routes
});

export default router;
